import { styled } from "@linaria/react";
import { breakpoints, colors } from "../../../../styles/utils/vars";
import { StyledList, StyledListItem } from "../../../List/StyledList";
import { getTypographyBase } from "../../../ui/Typography/Typography";
export const StyledStoresAvailable = /*#__PURE__*/styled('div')({
  name: "StyledStoresAvailable",
  class: "StyledStoresAvailable_s1b5whpb"
});

require("./StyledStoresAvailable.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledStoresAvailable.tsx");